import { Formik } from 'formik'
import * as Yup from 'yup'
import { Button, ModalBody, ModalFooter, ModalHeader } from '@ritualco/jutsu'
import { HeraModal } from 'components/HeraModal'
import { useContent } from 'lib/content/react'
import { MemberCreateModalForm } from './MemberCreateModalForm'
import { MemberCreateModalValues, MemberCreateModalProps } from './types'

export const MemberCreateModal = ({
  roles,
  onClose,
  onInvite,
  ...modalProps
}: MemberCreateModalProps) => {
  const { formatMessage } = useContent()
  const MemberCreateModalSchema = Yup.object({
    emails: Yup.array(Yup.string().email().required())
      .required()
      .min(1, formatMessage({ id: 'pmportal.settings.team.errors.emails' })),
    role: Yup.string().required(),
  })
  const initialValues: MemberCreateModalValues = {
    emails: [],
    role: roles?.[0].value,
  }

  return (
    <HeraModal size="2xl" onClose={onClose} {...modalProps}>
      <Formik<MemberCreateModalValues>
        initialValues={initialValues}
        onSubmit={async (values, actions) => {
          await onInvite(values, actions)
          actions.setSubmitting(false)
          onClose()
        }}
        validationSchema={MemberCreateModalSchema}
      >
        {props => (
          <>
            <ModalHeader>
              {formatMessage({ id: 'pmportal.settings.team.newMemberTitle' })}
            </ModalHeader>
            <ModalBody>
              <MemberCreateModalForm roles={roles} />
            </ModalBody>
            <ModalFooter>
              <Button colorScheme="transparent" mr={2} onClick={onClose}>
                {formatMessage({ id: 'pmportal.global.actionCancel' })}
              </Button>
              <Button
                type="submit"
                form="memberCreate"
                isLoading={props.isSubmitting}
              >
                {formatMessage({ id: 'pmportal.global.actionInvite' })}
              </Button>
            </ModalFooter>
          </>
        )}
      </Formik>
    </HeraModal>
  )
}
